
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/open-tax/partners/freeagent",
      function () {
        return require("private-next-pages/v2/open-tax/partners/freeagent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/open-tax/partners/freeagent"])
      });
    }
  